import Styled from "styled-components";

import SocialProofBG from "cms/images/social-proof-background-gradient.jpg";

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  padding: 2rem 1.5rem;
    overflow: hidden;
  background: url(${SocialProofBG}) center center / cover no-repeat;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 10rem);
    padding: 3rem 2.5rem;
  }
`;

export const Wrapper = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgb(255, 255, 255);
  border-radius: 24px;

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: 50%;
  }
`;

export const Illustration = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10rem;
  max-width: 10rem;
  height: 10rem;
  max-height: 10rem;
  border: 1px solid transparent;
  border-radius: 50%;
  overflow: hidden;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    width: 12.5rem;
    max-width: 12.5rem;
    height: 12.5rem;
    max-height: 12.5rem;
  }
`;

export const Message = Styled.div`
  display: flex;
  flex-flow: column;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 0 1.5rem;
  }
`;

export const Quote = Styled.div`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: -0.2px;
  text-align: center;

  & > p {
    margin: 0;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.25rem;
    line-height: 1.25rem;
  }
`;

export const CredentialsContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;
